var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.supplyMaterialService)?_c('b-card',[_c('b-card-body',[_c('b-card-title',[_vm._v(" "+_vm._s(_vm.$t("label.requestedSupplies"))+" ")]),_c('hr'),_c('b-card-text',[_c('b-row',[_c('b-col',[_c('supplies-table',{attrs:{"supplies":_vm.supplyMaterialService.supplies,"readonly":true}})],1)],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }